export default {
    message: {
        impersonation: "Stai ordinando per conto di «{name}»"
    }
}